// config.js
const currentURL = window.location.origin;

export const apiURL =
  currentURL.includes("localhost")
    ? "http://localhost:5000/api/"
    : "https://quotationbackendneon.vercel.app/api/";

// Neon is a separate deployment, so quotation branding never depends on document creators.
export const COMPANY_PREFIX = "NW-QT";
export const COMPANY_FINANCE_NAME = "NEON FINANCE";
export const COMPANY_LOGO_URL = "https://i.imgur.com/sfL5dWo.png";
